<template>
    <!-- show-multi-search -->
    <crm-content>
        <template v-slot:actionLeft>
            <vx-action-icon icon="MenuIcon" class="mr-4" @click="toggleSideBar" />
            <h4>{{ title }}</h4>
        </template>
        <template v-slot:actionRight>
            <vx-action-icon
                isButton
                icon="PlusIcon"
                color="primary"
                tooltip="New GP"
                @click="addGeneralPractitioner"
            />
        </template>
        <general-practitioners-table ref="table" />
        <general-practitioner-editor
            v-if="addPractitioner"
            add
            :active.sync="addPractitioner"
            @close="close"
        />
    </crm-content>
</template>

<script>
import GeneralPractitionersTable from './GeneralPractitionersTable.vue'

import CrmContent from '../../crm/components/CrmContent.vue'
import GeneralPractitionerEditor from './GeneralPractitionerEditor.vue'

export default {
    name: 'general-practitioners-main',
    components: {
        CrmContent,
        GeneralPractitionersTable,
        GeneralPractitionerEditor
    },
    data() {
        return {
            addPractitioner: false,
            title: 'General Practitioners'
        }
    },
    watch: {
        addPractitioner: {
            handler(val) {
                if (!val) {
                    this.close()
                }
            }
        }
    },
    methods: {
        addGeneralPractitioner() {
            this.addPractitioner = true
        },
        close() {
            this.addPractitioner = false
            this.$refs['table'].$refs.lineTable.reset()
        }
    },
    beforeMount() {},
    async created() {}
}
</script>
